module.exports = "<button class=\"kuiButton kuiButton--danger\">\n  Danger button\n</button>\n\n<hr class=\"guideBreak\">\n\n<button disabled class=\"kuiButton kuiButton--danger\">\n  Danger button, disabled\n</button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/button/button_danger.html
 ** module id = 723
 ** module chunks = 0
 **/